import {
  Component,
  Input,
  ContentChildren,
  QueryList,
  forwardRef,
  AfterContentInit,
  HostListener,
} from "@angular/core";

@Component({
  selector: "icn-navbar-menu-item",
  templateUrl: "./navbar-menu-item.component.html",
  styleUrls: ["./navbar-menu-item.component.scss"],
})
export class NavBarMenuItemComponent implements AfterContentInit {
  @Input() label: string;

  @Input()
  keyboardShortcut: string;

  @ContentChildren(forwardRef(() => NavBarMenuItemComponent))
  navBarMenuItems: QueryList<NavBarMenuItemComponent>;

  hasInnerMenu: boolean;
  innerMenuActive = false;

  ngAfterContentInit() {
    let self = this;
    this.hasInnerMenu =
      this.navBarMenuItems.filter((item) => item !== self).length > 0;
  }

  /**
   * Open Inner-Menu if exist
   * @param event
   */
  onClick(event) {
    event.preventDefault();

    if (this.hasInnerMenu) this.toggleInnerMenu();
  }

  toggleInnerMenu() {
    this.innerMenuActive = !this.innerMenuActive;
  }
}
